import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table } from "antd";
import "./Form.css";
import numeral from "numeral";
import moment from "moment-timezone";
import axios from "axios";

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class ComissaoVendaForm extends Component {
  state = {
    listaRegistros: [],
    pagina: 1,
    limite: 10,
    total: 0,

    totalComissoes: 0,
    carregando: false,
    vendedor: '',
    buscaDataIni: '',
    buscaDataFim: '',
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        totalComissoes: this.props.registroSelecionado.totalComissoes,
        vendedor: this.props.registroSelecionado.vendedor,
        buscaDataIni: this.props.registroSelecionado.buscaDataIni,
        buscaDataFim: this.props.registroSelecionado.buscaDataFim,
      }, () => {
        this.getListaRegistros();
      });
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite, vendedor, buscaDataIni, buscaDataFim } = this.state;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      axios
        .get('/vendas/listaComissoesVendedoresTitulos', {
          params: {
            page: pagina,
            limite: limite,
            vendedor,
            dataIni,
            dataFim,
            tipo: '',
          }
        })
        .then(response => {
          this.setState({
            listaRegistros: response.data,
            carregando: false,
          });
        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };


  renderData = (data, registro) => {
    if (data) {
      const dataMoment = this.props.tipo === 'todos' ? moment(data) : moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderValorVenda = (vlr, registro) => {
    if (this.props.tipo === 'todos') {
      return (
        <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
      );
    }
  };

  renderValorComissao = (vlr, registro) => {
    if (this.props.tipo === 'todos') {
      return (
        <span> {numeral(parseFloat(registro.tparc_valor * (registro.ue_perc_comissao / 100))).format('0,000.00')} </span>
      );
    } else {
      return (
        <span> {numeral(parseFloat(registro.pgto_vlr_pago * (registro.ue_perc_comissao / 100))).format('0,000.00')} </span>
      );
    }
  };

  renderParcela = (tparc_parcela, registro) => {
    return (
      <span> {tparc_parcela + ' / ' + registro.qtde_parcelas} </span>
    );
  };





  render() {
    const { onCancelarClick, visivel } = this.props;
    const { listaRegistros, totalComissoes, carregando } = this.state;

    // console.log('ComissaoVendaForm.this.props: ', this.props);
    // console.log('ComissaoVendaForm.this.state: ', this.state);

    return (
      <Modal
        title={"Detalhes da Comissão"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"80%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Row>
              <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                <span style={{ fontWeight: "bold" }}>Período: </span>
                <span>{this.props.periodo}</span>
              </Col>
            </Row>
            <Row>
              <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                <span style={{ fontWeight: "bold" }}>Total Comissões: </span>
                <span>R$ {this.renderValor(totalComissoes)}</span>
              </Col>
            </Row>

            <div style={{ marginTop: 10, marginBottom: 15 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaRegistros}
                rowKey={(registro => registro.tparc_idf + '_' + registro.tparc_parcela)}
              >
                <Column
                  key="ven_numero"
                  dataIndex="ven_numero"
                  title="Nº"
                  width={90}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ven_dt_venda"
                  dataIndex="ven_dt_venda"
                  title="Data Venda"
                  render={this.renderData}
                  width={120}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="pgto_data"
                  dataIndex="pgto_data"
                  title="Data Pagto"
                  render={this.renderData}
                  width={120}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="tparc_parcela"
                  dataIndex="tparc_parcela"
                  title="Parcela"
                  width={80}
                  align="center"
                  className="listaCadastro"
                  render={this.renderParcela}
                />
                <Column
                  key="situacao_parcela"
                  dataIndex="situacao_parcela"
                  title="Situação"
                  width={90}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="td_descricao"
                  dataIndex="td_descricao"
                  title="Tipo Docto"
                  width={120}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="tit_controle"
                  dataIndex="tit_controle"
                  title="Controle"
                  width={80}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="tit_numero"
                  dataIndex="tit_numero"
                  title="Número"
                  width={80}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="pes_nome"
                  dataIndex="pes_nome"
                  title="Nome"
                  width={200}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="tit_descricao"
                  dataIndex="tit_descricao"
                  title="Descrição"
                  width={200}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="pgto_vlr_pago"
                  dataIndex="pgto_vlr_pago"
                  title="Valor Parc"
                  render={this.renderValorVenda}
                  width={100}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key=""
                  dataIndex=""
                  title="Valor Comissão"
                  render={this.renderValorComissao}
                  width={130}
                  align="right"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ComissaoVendaForm.js